/* Bedragen opmaken zoals de WINKEL dat doet, niet zoals de browser dat zou doen.
 *
 * Waarom dit bestand bestaat: Liquid rendert bedragen met het money_format van de
 * winkel, terwijl Intl.NumberFormat de conventie van de taal volgt. Op een Duitse
 * winkel met een Nederlands ingesteld formaat leverde dat twee verschillende
 * schrijfwijzen op dezelfde pagina op: "€25,99" naast "25,99 €". Door overal dit
 * ene formaat te gebruiken lopen pagina, winkelwagen en kassa gelijk, en verandert
 * alles vanzelf mee zodra de eigenaar de winkelinstelling aanpast.
 *
 * window.__cdMoneyFormat wordt door snippets/cd-vars.liquid gezet.
 */
(function () {
  if (window.cdMoney) return;

  function metScheiders(getal, decimalen, duizend, decimaal) {
    if (isNaN(getal) || getal === null) getal = 0;
    var vast = (getal / 100).toFixed(decimalen);
    var delen = vast.split('.');
    var heel = delen[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + duizend);
    var rest = delen[1] ? decimaal + delen[1] : '';
    return heel + rest;
  }

  window.cdMoney = function (centen, formaat) {
    var f = formaat || window.__cdMoneyFormat || '{{amount}}';
    var uit = '';
    var patroon = /\{\{\s*(\w+)\s*\}\}/;
    var treffer = f.match(patroon);
    var naam = treffer ? treffer[1] : 'amount';

    switch (naam) {
      case 'amount':                                  uit = metScheiders(centen, 2, ',', '.'); break;
      case 'amount_no_decimals':                      uit = metScheiders(centen, 0, ',', '.'); break;
      case 'amount_with_comma_separator':             uit = metScheiders(centen, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': uit = metScheiders(centen, 0, '.', ','); break;
      case 'amount_with_space_separator':             uit = metScheiders(centen, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': uit = metScheiders(centen, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator':        uit = metScheiders(centen, 2, "'", '.'); break;
      default:                                        uit = metScheiders(centen, 2, ',', '.');
    }

    return f.replace(patroon, uit);
  };
})();
